// src/layouts/SuperAdminLayout.js
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import SuperAdminSidebar from '../SuperAdminSidebar';



const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  margin-left: ${props => props.sidebarOpen ? '240px' : '64px'};
  transition: margin 0.3s ease;
  background: #f8fafc;
  min-height: 100vh;
`;

const SuperAdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <LayoutContainer>
      <SuperAdminSidebar 
        open={sidebarOpen} 
        handleDrawerToggle={() => setSidebarOpen(!sidebarOpen)} 
      />
      <Content sidebarOpen={sidebarOpen}>
        <Outlet /> {/* This will render nested routes */}
      </Content>
    </LayoutContainer>
  );
};

export default SuperAdminLayout;